import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const kitItems = [{
  title: 'Ebook Maestro',
  subtitle: 'El Código Invisible del Dinero',
  description: 'Sistema paso a paso para reprogramar tu patrón interno.',
  image: 'https://cdn.magicpatterns.com/uploads/iWimrgztMff35AKnRwAAP8/Ebook_inicial.png',
  isMain: true,
  features: ['El ejercicio de 7 minutos para detectar tu patrón automático con el dinero', 'El ritual de reprogramación que cambia cómo tomas decisiones en tiempo real', 'El sistema para dejar de sentir ansiedad al recibir o gastar dinero', 'La estructura para estabilizar ingresos sin esfuerzo constante']
}, {
  title: 'Bono 1: Guionismo de Realidades',
  subtitle: 'Reescribe tu historia',
  description: 'Aprende a rediseñar tu narrativa interna y dejar de sabotearte.',
  image: 'https://cdn.magicpatterns.com/uploads/tHaUo3Q2fteRSt3z8qZjaH/Bonos_1.png',
  isMain: false
}, {
  title: 'Bono 2: Mapa de los 5 Canales',
  subtitle: 'Fuentes de ingreso',
  description: 'Crea múltiples fuentes de ingreso alineadas contigo.',
  image: 'https://cdn.magicpatterns.com/uploads/qBT1S5rWH7vN2jdgswgyYM/Bonos_2.png',
  isMain: false
}, {
  title: 'Bono 3: Billetera Magnética',
  subtitle: 'Orden y limpieza',
  description: 'Checklist práctico para ordenar tu relación real con el dinero.',
  image: 'https://cdn.magicpatterns.com/uploads/2o2rABF6mjBvDBGuDRLwtk/Bonos_3.png',
  isMain: false
}];
export function KitSection() {
  return <section className="py-24 bg-[#FAF5E9]" data-id="element-66">
      <div className="max-w-6xl mx-auto px-6" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-900 mb-4" data-id="element-69">
            Tu Kit de Transformación
          </h2>
          <p className="text-stone-600 text-lg max-w-2xl mx-auto" data-id="element-70">
            Todo lo que necesitas para cambiar tu relación con el dinero desde
            hoy:
          </p>
        </div>

        <div className="space-y-16 md:space-y-24" data-id="element-71">
          {kitItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 md:gap-16`} data-id="element-72">
              <div className="w-full md:w-1/2" data-id="element-73">
                <div className={`relative rounded-2xl overflow-hidden shadow-2xl ${item.isMain ? 'ring-4 ring-[#C5A059]/20' : ''}`} data-id="element-74">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover hover:scale-105 transition-transform duration-700" data-id="element-75" />
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-4" data-id="element-76">
                {item.isMain && <span className="inline-block py-1 px-3 rounded-full bg-[#C5A059] text-white text-xs font-bold tracking-wider uppercase mb-2" data-id="element-77">
                    Material Principal
                  </span>}
                {!item.isMain && <span className="inline-block py-1 px-3 rounded-full bg-stone-200 text-stone-700 text-xs font-bold tracking-wider uppercase mb-2" data-id="element-78">
                    Regalo Exclusivo
                  </span>}
                <h3 className="text-3xl font-serif font-bold text-stone-900" data-id="element-79">
                  {item.title}
                </h3>
                <h4 className="text-xl text-[#A8823A] font-medium italic font-serif" data-id="element-80">
                  {item.subtitle}
                </h4>
                <p className="text-stone-600 text-lg leading-relaxed" data-id="element-81">
                  {item.description}
                </p>

                {item.features && <div className="mt-6 bg-white/50 p-6 rounded-xl border border-[#C5A059]/20 shadow-sm" data-id="element-82">
                    <p className="font-bold text-stone-900 mb-4 font-serif text-lg" data-id="element-83">
                      📖 Dentro del Ebook vas a encontrar:
                    </p>
                    <ul className="space-y-3" data-id="element-84">
                      {item.features.map((feat, i) => <li key={i} className="flex items-start gap-3 text-stone-700 text-sm leading-relaxed" data-id="element-85">
                          <span className="text-[#C5A059] mt-0.5 font-bold" data-id="element-86">
                            ✔
                          </span>
                          <span data-id="element-87">{feat}</span>
                        </li>)}
                    </ul>
                  </div>}

                <ul className="space-y-2 pt-4" data-id="element-88">
                  <li className="flex items-start gap-2 text-stone-700" data-id="element-89">
                    <CheckCircle2 className="w-5 h-5 text-[#C5A059] shrink-0 mt-0.5" data-id="element-90" />
                    <span data-id="element-91">Acceso digital inmediato</span>
                  </li>
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}